import React, { ReactNode, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export type TooltipProps = {
  text: string;
  children: ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  const triggerRef = useRef<HTMLSpanElement | null>(null);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);

  const showTooltip = () => {
    if (!triggerRef.current || !text) return;

    const rect = triggerRef.current.getBoundingClientRect();
    setPosition({
      top: rect.bottom + 8,
      left: rect.left + rect.width / 2,
    });
  };

  return (
    <span
      ref={triggerRef}
      className="tooltip-container"
      onMouseEnter={showTooltip}
      onMouseLeave={() => setPosition(null)}
      onFocus={showTooltip}
      onBlur={() => setPosition(null)}
    >
      <span>{children}</span>
      {position && text
        ? createPortal(
            <span
              className="tooltip-bubble"
              style={{
                position: "fixed",
                top: position.top,
                left: position.left,
                opacity: 1,
                zIndex: 10000,
              }}
            >
              {text}
            </span>,
            document.body,
          )
        : null}
    </span>
  );
};

export default Tooltip;
